import { LicenseManager } from 'ag-grid-enterprise';
import {
  usePostLoginMutation,
  usePostLoginNoCredentialsMutation,
} from 'api/auth/authApi';
import { useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { consoleErrorMessage } from 'utils/commonFunctions/CommonFunctions';
import Config from '../../../config.json';
import { NOTIFICATION_BOX_MESSAGES } from 'utils/common-constants';
import { userAtom } from './userAtom';

export const useLogin = () => {
  const [login, { isLoading: isLoging }] = usePostLoginMutation();
  const setUser = useSetAtom(userAtom);
  const [loginNoCredentials, { isLoading: isLoginNoCredentials }] =
    usePostLoginNoCredentialsMutation();

  const isLoading = useMemo(
    () => isLoging || isLoginNoCredentials,
    [isLoging, isLoginNoCredentials]
  );

  const sendLoginNoCredentials = async () => {
    try {
      const response = await loginNoCredentials(null).unwrap();
      window.location.href = response.redirect;
    } catch (error) {
      localStorage.setItem('authError', NOTIFICATION_BOX_MESSAGES.AUTH_ERROR);
      consoleErrorMessage(error);
    }
  };

  const sendLoginNoCredentialsNoRedirect = async () => {
    try {
      loginNoCredentials(null).unwrap();
    } catch (error) {
      localStorage.setItem('authError', NOTIFICATION_BOX_MESSAGES.AUTH_ERROR);
      consoleErrorMessage(error);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get('code');

    login(null)
      .unwrap()
      .then((data) => {
        setUser(data);
        localStorage.setItem('authError', '');
      })
      .catch((error) => {
        localStorage.setItem('authError', NOTIFICATION_BOX_MESSAGES.AUTH_ERROR);
        if (error.status === 401 || error.status === 403) {
          if (!code) {
            sendLoginNoCredentials();
          } else {
            sendLoginNoCredentialsNoRedirect();
          }
        } else if (error.status === 500 && code) {
          queryParams.delete('code');
          login(null);
        } else if (
          error.status === 503 ||
          error.status === 502 ||
          error.originalStatus === 503 ||
          error.originalStatus === 502 ||
          error.status === 504 ||
          error.originalStatus === 504
        ) {
          localStorage.setItem(
            'authError',
            NOTIFICATION_BOX_MESSAGES.SERVICE_UNAVAILABLE
          );
        }
      });

    LicenseManager.setLicenseKey(Config?.REACT_APP_AG_GRID_LICENCE);
  }, [login]);

  return { isLoading };
};
